import type { FaireProductEntity } from "../../entity_types/product";

export const p_amh5h6pk5v: FaireProductEntity = {
  token: "p_amh5h6pk5v",
  type: "product",
  name: "Juniper Necklace",
  brandToken: "b_859446c0",
  brandName: "Jessica Matrasko Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/e825a4e6c4885a67eb9534d712705089d317d21a2494608d8048086bd8010f78.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/07633db453f9b976f899c1f989cb9c2643a3ad92dd6f33c8f9cba5a35ab6a0fc.jpeg",
    "https://cdn.faire.com/fastly/3da42544cc234878b2335273e40b407c0fdf1627c75017a0121b3bf922fb16df.jpeg",
  ],
  priceDollars: 36,
  description:
    'Multi gemstone hand beaded necklace—each one is unique!\n\n• hand beaded gemstones\n• gold filled materials\n• total length 16"',
  tags: [],
  msrpDollars: 72,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:56.459Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
